var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7d7d7d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    className: "cls-1",
    d: "M52,13.5a36,36,0,1,0,36,36A36,36,0,0,0,52,13.5ZM52,81A31.5,31.5,0,1,1,83.5,49.5,31.53,31.53,0,0,1,52,81Zm-.49-15.74h4.16V60H51.51ZM59.79,34a10.36,10.36,0,0,0-3.37-1.91,13.11,13.11,0,0,0-8.69.23A10.71,10.71,0,0,0,44,34.81a10.25,10.25,0,0,0-2.33,3.86A14.23,14.23,0,0,0,41,43.33h4.5a10,10,0,0,1,.48-3.2,5.9,5.9,0,0,1,1.31-2.19,6.12,6.12,0,0,1,2.15-1.42A8.58,8.58,0,0,1,55,36.38a5.72,5.72,0,0,1,1.89,1.06,4.81,4.81,0,0,1,1.23,1.63A5.81,5.81,0,0,1,57.87,44a14.05,14.05,0,0,1-2.24,2.67c-.82.83-1.48,1.47-2,1.94a8.08,8.08,0,0,0-1.58,2A7.38,7.38,0,0,0,51.36,53c-.09.72-.15,1.74-.18,3.09l4.5.1c0-1.16.07-2,.14-2.64a2.56,2.56,0,0,1,.24-.91,3.32,3.32,0,0,1,.69-.84c.51-.49,1.2-1.16,2-2a18.4,18.4,0,0,0,2.91-3.5A9.35,9.35,0,0,0,63,41.29a9.56,9.56,0,0,0-.87-4.14A9.31,9.31,0,0,0,59.79,34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutline);
export default __webpack_public_path__ + "static/media/help-outline.449d0539f97e52675f57dc89064d689d.svg";
export { ForwardRef as ReactComponent };